<template>
    <div class="p-4 bg-gray-50 border border-gray-200 rounded-xl">
        <ui-form-section class="mb-4">
            <template v-if="item.in_use">
                <ui-date-picker label="Date In" name="in" :error="form.errors.get('in')" v-model="form.in" placeholder="Date in..."></ui-date-picker>
            </template>
            <template v-else>
                <ui-date-picker label="Date Out" name="out" :error="form.errors.get('out')" v-model="form.out" placeholder="Date out..." class="xl:col-span-6"></ui-date-picker>
                <ui-select-searchable
                    label="Contact"
                    placeholder="Used by..."
                    v-model="form.contact"
                    :error="form.errors.get('contact_id')"
                    :search="searchSuppliers"
                    no-search="Start typing to find people or companies..."
                    class="xl:col-span-6"
                ></ui-select-searchable>
            </template>
        </ui-form-section>
        <div class="flex justify-end space-x-4">
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">Add Usage Entry</ui-button-new>
        </div>
    </div>
</template>

<script>
import { Supplier } from '@models'

export default {
    props: {
        item: Object,
    },
    data () {
        return {
            form: new Form({}, async (form) => {
                await this.item.addUsage(form.export())
                await this.item.refresh()
                form.reset()

            }),
        }
    },
    methods: {
        async searchSuppliers (query) {
            return (await Supplier.search(query)).map(x => x.toDropdown())
        },
    },
}
</script>
